<template>
    <v-card>
        <v-card-title>
            <span class="headline">{{ editar ? 'Editar tipo precio' : 'Nuevo tipo precio' }}</span>
        </v-card-title>

        <v-card-text>
            <v-alert
                v-model="mostrar_alert"
                dismissible
                :type="type_alert"
            >
                <template v-html="html_alert"/>
            </v-alert>

            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex
                        xs12
                        sm6
                    >
                        <v-text-field
                            :value="item.nombre"
                            :error-messages="error_input.nombre"
                            label="Nombre"
                            @input="(payload) => form.nombre = payload"
                        />
                    </v-flex>
                    <v-flex
                        xs12
                        sm6
                    >
                        <v-select
                            :value="item.recompensa"
                            :error-messages="error_input.recompensa"
                            :items="[{value : true, text : 'Activar'},{value : false, text : 'Desactivar'}]"
                            item-text="text"
                            item-value="value"
                            label="Recompensas"
                            hint='Activar las recompensas por pedido completado'
                            @input="(payload) => form.recompensa = payload"
                        />
                    </v-flex>
                    <v-flex
                        xs12
                        sm6
                    >
                        <v-text-field
                            :value="item.porcentaje"
                            min="1"
                            type="number"
                            :error-messages="error_input.porcentaje"
                            label="% por pedido"
                            hint="Porcentaje que será abonado como recompensa en el monedero del cliente por cada pedido completado. Se toma como base el monto del pedido"
                            @input="(payload) => form.porcentaje = payload"
                        />
                    </v-flex>
                    <v-flex
                        xs12
                        sm6
                    >
                        <v-text-field
                            :value="item.saldo_maximo"
                            :error-messages="error_input.saldo_maximo"
                            min="0"
                            type="number"
                            label="Saldo máximo"
                            hint='Este campo permite limitar el monto máximo para aplicar como recompensa en el monedero del cliente. Si se configura como "0" significa "Sin límite".'
                            @input="(payload) => form.saldo_maximo = payload"
                        />
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="gray darken-1"
                @click="close"
            >
                Cancelar
            </v-btn>
            <v-btn
                color="blue darken-1"
                class="white--text"
                :loading="loading"
                :disabled="loading"
                @click="guardar"
            >
                Guardar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from 'axios';
    import EventBus from "@/EventBus";

    export default {
        name: "FormTipoPrecio",
        props: {
            item: {
                type: [Array, Object],
                default: () => {
                    return {
                        id: 0,
                        nombre: '',
                        saldo_maximo : 0,
                        porcentaje : 1,
                        recompensa : false,
                    }
                }
            }
        },
        data() {
            return {
                form: Object.assign({id: 0,nombre: '',saldo_maximo : 0,porcentaje : 1,recompensa : false,}, this.$_clonar(this.item)),
                error_input: {
                    nombre: '',
                },
                loading: false,
                mostrar_alert: false,
                type_alert: 'success',
                html_alert: ''
            }
        },
        computed: {
            editar() {
                return this.item.id > 0;
            }
        },
        watch: {
            item(val) {
                this.form = Object.assign({}, val);
            }
        },
        methods: {
            close() {
                this.form.id = 0;
                this.form.nombre = '';
                this.$emit('close', true);
            },
            guardar() {
                let url_target = this.editar ? '/api/tipo-precio/actualizar/' + this.item.id : '/api/tipo-precio/guardar';
                this.loading = true;
                this.error_input.nombre = '';
                axios.post(url_target, this.form)
                    .then((success) => {
                        let {data} = success;
                        this.loading = false;
                        /*window.console.log('IsData', data);*/
                        if (data.success) {
                            this.form.nombre = '';
                            this.$emit('save', data.message);
                            EventBus.$emit('tugarrafon:show-snackbar',{
                                text_content : data.message,
                                color : 'success'
                            });
                        }
                    })
                    .catch((error) => {
                        this.loading = false;

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.error_input = Object.assign({}, error.response.data.data)
                                EventBus.$emit('tugarrafon:show-snackbar',{
                                    text_content : error.response.data.message,
                                    color : 'error'
                                })
                            }
                        } else {
                            EventBus.$emit('tugarrafon:show-snackbar',{
                                text_content : 'Error inesperado. Intenta nuevamente por favor',
                                color : 'error'
                            })
                        }
                    })
            }
        }
    }
</script>

<style scoped>

</style>
